(() => {
  if (window.MCArticleLightbox) return

  const gallerySelector = '[data-mc-article-gallery], [data-mc-product-gallery]'
  const linkSelector = 'a[data-pswp-width][data-pswp-height]'
  const galleryLinkSelector = gallerySelector
    .split(',')
    .map((selector) => `${selector.trim()} ${linkSelector}`)
    .join(', ')
  const photoSwipeBaseUrl = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/'
  let lightboxPromise

  const loadStyles = () => {
    if (document.querySelector('link[data-mc-photoswipe-style]')) return

    const stylesheet = document.createElement('link')
    stylesheet.rel = 'stylesheet'
    stylesheet.href = `${photoSwipeBaseUrl}photoswipe.css`
    stylesheet.dataset.mcPhotoswipeStyle = ''
    document.head.appendChild(stylesheet)
  }

  const loadPhotoSwipe = () => {
    if (lightboxPromise) return lightboxPromise

    loadStyles()

    lightboxPromise = import(`${photoSwipeBaseUrl}photoswipe-lightbox.esm.min.js`)
      .then(({ default: PhotoSwipeLightbox }) => {
        const lightbox = new PhotoSwipeLightbox({
          gallery: gallerySelector,
          children: linkSelector,
          pswpModule: () => import(`${photoSwipeBaseUrl}photoswipe.esm.min.js`),
          showHideAnimationType: 'zoom',
          wheelToZoom: true,
          escKey: true,
          arrowKeys: true
        })

        lightbox.init()
        return lightbox
      })

    return lightboxPromise
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest(galleryLinkSelector)
    if (!link) return

    event.preventDefault()

    const gallery = link.closest(gallerySelector)
    const links = [...gallery.querySelectorAll(linkSelector)]
    const index = links.indexOf(link)
    const dataSource = links.map((galleryLink) => ({
      src: galleryLink.href,
      width: Number(galleryLink.dataset.pswpWidth),
      height: Number(galleryLink.dataset.pswpHeight),
      alt: galleryLink.querySelector('img')?.alt || ''
    }))

    loadPhotoSwipe()
      .then((lightbox) => lightbox.loadAndOpen(index, dataSource))
      .catch((error) => {
        console.error('Unable to load gallery lightbox', error)
        window.location.href = link.href
      })
  })

  window.MCArticleLightbox = true
})()
